import { render, staticRenderFns } from "./CardSkeleton.vue?vue&type=template&id=7967dfe4&"
var script = {}
import style0 from "./CardSkeleton.vue?vue&type=style&index=0&id=7967dfe4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports